import { Spinner } from "react-bootstrap";
// import { useState, useMemo } from "react";

// import React, { useState } from "react";
// import { IoMdSearch } from "react-icons/io";

const getStatusBgColor = (status) => {
  switch (status.toLowerCase()) {
    case "external_open":
      return "#cce5ff"; // Light Blue
    case "approved":
      return "#d4edda"; // Light Green
    case "inprogress":
    case "in_progress":
      return "#fff3cd"; // Light Yellow
    case "hold":
      return "#f0f0f0"; // Very Light Gray
    case "closed":
      return "#e2f0d9"; // Light Mint Green
    case "rejected":
      return "#f8d7da"; // Light Red
    case "assigned":
      return "#e0e7ff"; // Light Indigo
    case "close_requested":
      return "#ffe6e6"; // Light Pink
    default:
      return "black";
  }
};

const getStatusColor = (status) => {
  switch (status.toLowerCase()) {
    case "External_open":
      return "#007bff"; // Blue
    case "approved":
      return "#218838"; // Dark Green
    case "inprogress":
    case "in progress":
      return "#856404"; // Brownish Yellow
    case "hold":
      return "#6c757d"; // Gray
    case "closed":
      return "#2e8540"; // Deep Green
    case "rejected":
      return "#c82333"; // Crimson
    case "assigned":
      return "#4e5d94"; // Indigo
    case "close_requested":
      return "#c41e3a"; // Ruby Red
    default:
      return "black";
  }
};

export const StatusCell = ({ status }) => (
  <span
    style={{
      // color: "#fff",
      backgroundColor: getStatusBgColor(status),
      color: getStatusColor(status),
      padding: "4px 10px",
      borderRadius: "12px",
      fontSize: "0.8rem",
      fontWeight: 500,
      display: "inline-block",
      textTransform: "capitalize",
    }}
  >
    {status}
  </span>
);
export function formatDateTime(timestamp) {
  const date = new Date(timestamp);

  const options = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true, // ✅ Enables AM/PM
    timeZone: "Asia/Kolkata", // You can adjust based on location
  };

  return date.toLocaleString("en-IN", options);
}
const styles = {
  loaderOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    background: "rgba(255, 255, 255, 0.6)",
    backdropFilter: "blur(5px)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999,
  },
};

export const Loader = () => (
  <div style={styles.loaderOverlay}>
    <Spinner
      animation="border"
      role="status"
      variant="primary"
      style={{ width: "5rem", height: "5rem" }}
    >
      <span className="visually-hidden">Loading...</span>
    </Spinner>
  </div>
);

export const formatDatetimeNew = (datetimeStr) => {
  const date = new Date(datetimeStr);
  const pad = (n) => String(n).padStart(2, "0");

  const year = date.getFullYear();
  const month = pad(date.getMonth() + 1); // months are 0-indexed
  const day = pad(date.getDate());
  const hours = pad(date.getHours());
  const minutes = pad(date.getMinutes());
  const seconds = pad(date.getSeconds());

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};

// export default function TableComponent({ tableColumns, tableData }) {
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage, setItemsPerPage] = useState(10);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [statusFilter, setStatusFilter] = useState("");
//   const [startDate, setStartDate] = useState("");
//   const [endDate, setEndDate] = useState("");

//   // Memoize filtered data for performance
//   const filteredData = useMemo(() => {
//     return tableData.filter((row) => {
//       const rowDate = row.time
//         ? new Date(
//             row.time
//               .replace(",", "")
//               .replace(/(\d{2})-(\d{2})-(\d{4})/, "$3-$2-$1")
//           )
//         : null;

//       const matchesSearch = tableColumns.some((col) =>
//         String(row[col.accessor] || "")
//           .toLowerCase()
//           .includes(searchQuery.toLowerCase())
//       );

//       const matchesStatus =
//         !statusFilter ||
//         (row.raw_status &&
//           row.raw_status.toLowerCase() === statusFilter.toLowerCase());

//       const matchesDateRange =
//         !rowDate ||
//         (!startDate && !endDate) ||
//         (!startDate && rowDate <= new Date(endDate)) ||
//         (!endDate && rowDate >= new Date(startDate)) ||
//         (new Date(startDate) <= rowDate && rowDate <= new Date(endDate));

//       return matchesSearch && matchesStatus && matchesDateRange;
//     });
//   }, [tableData, searchQuery, statusFilter, startDate, endDate, tableColumns]);

//   // Pagination logic
//   const indexOfLastItem = currentPage * itemsPerPage;
//   const currentItems = filteredData.slice(
//     indexOfLastItem - itemsPerPage,
//     indexOfLastItem
//   );

//   // Handlers
//   const handleItemsPerPageChange = (e) => {
//     setItemsPerPage(Number(e.target.value));
//     setCurrentPage(1);
//   };

//   const handleSearchChange = (e) => {
//     setSearchQuery(e.target.value);
//     setCurrentPage(1);
//   };

//   return (
//     <div style={{ marginTop: "20px" }}>
//       {/* Search & Filters */}
//       <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
//         <div style={{ display: "flex", alignItems: "center" }}>
//           <img
//             width="24"
//             height="24"
//             src="https://img.icons8.com/material-rounded/24/search.png"
//             alt="search"
//             style={{ marginRight: "8px" }}
//           />
//           <input
//             type="text"
//             placeholder="Search..."
//             value={searchQuery}
//             onChange={handleSearchChange}
//             style={{
//               flex: 1,
//               padding: "8px",
//               borderRadius: "4px",
//               border: "1px solid #ccc",
//             }}
//           />
//         </div>
//         <div style={{ display: "flex", gap: "4%" }}>
//           {tableData.some((row) => "raw_status" in row) && (
//             <>
//               <div
//                 style={{ display: "flex", gap: "10px", alignItems: "center" }}
//               >
//                 <label>
//                   <strong>From</strong>
//                 </label>
//                 <input
//                   type="datetime-local"
//                   value={startDate}
//                   onChange={(e) => setStartDate(e.target.value)}
//                   className="form-control"
//                 />
//                 <label>
//                   <strong>To</strong>
//                 </label>
//                 <input
//                   type="datetime-local"
//                   value={endDate}
//                   onChange={(e) => setEndDate(e.target.value)}
//                   className="form-control"
//                 />
//               </div>

//               <div
//                 style={{ display: "flex", gap: "10px", alignItems: "center" }}
//               >
//                 <label>
//                   <strong>Ticket Status</strong>
//                 </label>
//                 <select
//                   className="form-select"
//                   value={statusFilter}
//                   onChange={(e) => setStatusFilter(e.target.value)}
//                 >
//                   <option value="">Select</option>
//                   <option value="external_open">Open</option>
//                   <option value="external_approved">Approved</option>
//                   <option value="assigned">Assigned</option>
//                   <option value="inprogress">In Progress</option>
//                   <option value="close requested">Close Requested</option>
//                   <option value="closed">Closed</option>
//                 </select>
//                 <span>
//                   Count: <strong>{filteredData.length}</strong>
//                 </span>
//               </div>
//             </>
//           )}
//         </div>
//       </div>

//       {/* Table */}
//       <div style={{ overflowX: "auto", marginTop: "20px" }}>
//         <table className="table table-bordered table-sm">
//           <thead className="table-primary">
//             <tr style={{ backgroundColor: "rgb(28,70,242)" }}>
//               {tableColumns.map((col, index) => (
//                 <th key={index}>{col.Header}</th>
//               ))}
//             </tr>
//           </thead>
//           <tbody>
//             {currentItems.length > 0 ? (
//               currentItems.map((row, i) => (
//                 <tr key={i}>
//                   {tableColumns.map((col, j) => (
//                     <td key={j}>
//                       {col.accessor === "status" ? (
//                         <span
//                           style={{
//                             backgroundColor:
//                               row[col.accessor] === "APPROVED"
//                                 ? "#d4edda"
//                                 : row[col.accessor] === "REJECTED"
//                                 ? "#f8d7da"
//                                 : "transparent",
//                             color:
//                               row[col.accessor] === "APPROVED"
//                                 ? "#155724"
//                                 : row[col.accessor] === "REJECTED"
//                                 ? "#721c24"
//                                 : "inherit",
//                             padding:
//                               row[col.accessor] === "APPROVED" ||
//                               row[col.accessor] === "REJECTED"
//                                 ? "4px 8px"
//                                 : "inherit",
//                             borderRadius: "4px",
//                             fontWeight: "bold",
//                           }}
//                         >
//                           {row[col.accessor]}
//                         </span>
//                       ) : (
//                         row[col.accessor]
//                       )}
//                     </td>
//                   ))}
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan={tableColumns.length} className="text-center">
//                   No data available
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>

//       {/* Pagination */}
//       <div
//         style={{
//           marginTop: "20px",
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//         }}
//       >
//         <div>
//           <label style={{ marginRight: "10px" }}>Items per page:</label>
//           <select
//             value={itemsPerPage}
//             onChange={handleItemsPerPageChange}
//             className="form-select form-select-sm"
//             style={{ width: "80px", display: "inline-block" }}
//           >
//             {[5, 10, 20, 50].map((n) => (
//               <option key={n} value={n}>
//                 {n}
//               </option>
//             ))}
//           </select>
//         </div>
//         <div>
//           <button
//             className="btn btn-outline-primary btn-sm me-2"
//             onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
//             disabled={currentPage === 1}
//           >
//             {"<<"}
//           </button>
//           <span>
//             Page {currentPage} of{" "}
//             {Math.ceil(filteredData.length / itemsPerPage)}
//           </span>
//           <button
//             className="btn btn-outline-primary btn-sm ms-2"
//             onClick={() => setCurrentPage((p) => p + 1)}
//             disabled={
//               currentPage >= Math.ceil(filteredData.length / itemsPerPage)
//             }
//           >
//             {">>"}
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }
